import { Component, input } from '@angular/core';

import { ApInputSkeletonComponent, ApParagraphSkeletonComponent, ApButtonSkeletonComponent } from '@ap/skeleton';

/**
 * @ngdoc component
 * @name ApDigipasSkeletonComponent
 */
@Component({
    selector: 'ap-digipas-skeleton',
    templateUrl: './skeleton.component.html',
    styleUrls: ['./skeleton.component.scss'],
    imports: [ApInputSkeletonComponent, ApParagraphSkeletonComponent, ApButtonSkeletonComponent]
})
export class ApDigipasSkeletonComponent {
    /**
     * Required - Is user anonymous
     */
    public readonly anonymous = input.required<boolean>();
}
